import React from 'react'

const AdditionalComponentHeader = ({switchTab,
    header,
    setHeader,
    searchFilter,
    setIsOpenSetting,
}) => {
    const handleSelectAll=(e)=>{
        if(e.target.checked){
            header?.filter((ele)=>ele?.default===false)?.forEach((ele,index) => {
                header[ele?.index].show=true;
            });
        }else{
            header?.filter((ele)=>ele?.default===false)?.forEach((ele,index) => {
                header[ele?.index].show=false;
            }); 
        }
        setHeader([...header])
    }
  return (
    <div>
    <div
      className="d-flex justify-content-between border-bottom modalHeader"
      style={{ borderRadius: "10px 10px 0px 0px" }}
    >
      <h4 className="font-bold text-black">Choose To Filter Table</h4>
      <button
        type="button"
        className="btn-close history-close"
        aria-label="Close"
        data-bs-dismiss="modal"
        onClick={() => {
          setIsOpenSetting(false);
        }}
      ></button>
    </div>
    <div className="select-time-interval ps-3 pe-3" id="andimni">
      {header?.length > 0 && (
        <>
          {header?.filter((ele)=>ele?.default===false).map((ele, index) => (
            <div className="d-flex gap-3">
              <div style={{ fontSize: "15px", padding: "3px" }}>
                <input
                  className="form-check-input"
                  type="checkbox"
                  checked={ele?.show===true}
                  onChange={(e) => {
                    
                    if (e.target.checked) {
                      header[ele?.index].show=true;
                    } else {
                        header[ele?.index].show=false;
                    }
                    

                    setHeader([...header])
                  }}
                  //disabled={ele?.default===true}
                />
              </div>
              <label style={{ fontSize: "13px", padding: "3px" }}>
                {ele?.label}
              </label>
            </div>
          ))}
        </>
      )}
    </div>
    <div className="modal-footer modal-footer-admin accept-reject-btns  accept-reject-btns-admin bottom-0">
      <div>
        <input
          type="checkbox"
          className="form-check-input"
          onClick={(e) => {
            handleSelectAll(e);
          }}
          checked={
          header?.filter((ele)=>(ele?.show===true && ele?.default===false))?.length===header?.filter((ele)=>ele?.default===false)?.length
          }
        />
        <label
          className="margin-right"
          style={{ marginLeft: "10px", fontWeight: "600" }}
        >
          Select All
        </label>
      </div>
      {/* <div>
        <button
          type="button"
          className="savedetails"
          aria-label="Close"
          data-bs-dismiss="modal"
          onClick={() => {
            setIsOpenSetting(false);
          }}
        >
          Show Selected
        </button>
      </div> */}
    </div>
  </div>
  )
}

export default AdditionalComponentHeader